import type { IdentifiesRomanticallyOptionIdType } from '../../types';

export const IDENTIFIES_ROMANTICALLY_OPTIONS_FEMALE: {
  id: IdentifiesRomanticallyOptionIdType;
  title: string;
}[] = [
  { id: 'straight', title: '🧔‍♂️ Straight' },
  { id: 'lesbian', title: '👩 Lesbian' },
  { id: 'bisexual', title: '👩‍❤️‍👨 Bisexual' },
  { id: 'asexual', title: '💔 Asexual' },
  { id: 'open_to_anything', title: '❤️‍🔥 Open to anything' },
];

export const IDENTIFIES_ROMANTICALLY_OPTIONS_MALE: {
  id: IdentifiesRomanticallyOptionIdType;
  title: string;
}[] = [
  { id: 'straight', title: '👩 Straight' },
  { id: 'gay', title: '🧔‍♂️ Gay' },
  { id: 'bisexual', title: '👩‍❤️‍👨 Bisexual' },
  { id: 'asexual', title: '💔 Asexual' },
  { id: 'open_to_anything', title: '❤️‍🔥 Open to anything' },
];
